"use strict";

import DomHelper from './Dom';
import ElementCache from '../Models/ElementCache';

export default class DomUpdater {

	/**
     * Update values in HTML elements from key/value-pairs
     * @param {Object} obj
     * @return
     */
	static updateValues(obj)
	{
		let self = this;
		let allowedTypes = ['string', 'number'];

		for (let key in obj) {
			if (allowedTypes.includes(typeof obj[key])) {
				let value = typeof obj[key] === 'number' ? obj[key].toString() : obj[key];
				let element = self._getDomElement(key);
				if (element) {
					element.innerHTML = value;
				}
			}
		}
	}

	static flushElementCache()
	{
		ElementCache.flush();
	}

	/**
	 * Get dom element from identifier (the identifier and be both class and id)
	 * The function will search the cache first and then the DOM
	 * @param {String} identifier
	 * @param refreshCache
	 * @return
	 */
	static _getDomElement(identifier, refreshCache = false)
	{
		const prefix = "#sparxpres-";
		identifier =  prefix + identifier;

		if (refreshCache) {
			ElementCache.remove(identifier);
		}

		if (!ElementCache.get(identifier)) {
			let domElement = DomHelper.grepElementIgnoreErrors(identifier);
			if (domElement) {
				ElementCache.set(identifier, domElement);
			}
		}

		return ElementCache.get(identifier);
	}

}
